import { FC, PropsWithChildren } from 'react';
import { Panel } from '@cbridge-tools/resizable-panels';
import { SINGLE_FILTER_HEADER_HEIGHT } from '@cbridge-tools/filters-panel';
import { IFlexNavigationPanelProps } from './FlexNavigationPanel.interface';

export const FlexNavigationPanel: FC<PropsWithChildren<IFlexNavigationPanelProps>> = (props) => {
  const { id, children, defaultSize, minSize, minHeight } = props;

  return (
    <Panel
      id={id}
      minSize={minSize}
      defaultSize={defaultSize}
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: minHeight ?? SINGLE_FILTER_HEADER_HEIGHT * 3,
      }}
    >
      {children}
    </Panel>
  );
};
